import { CxAlertsService } from './../../../libs/components/cx-alerts/cx-alerts.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ɵConsole } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './../../../auth/auth.service';
import { DatabaseService } from '@app/database/database.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

public loggedUser: string;

constructor(
    private http: HttpClient,
    private authService: AuthService,
    private router: Router,
    private databaseService: DatabaseService,
    private alertService: CxAlertsService
  ) {

     this.loggedUser = authService.currentUserValue.modelName;
  }

  ngOnInit(): void {
  }


  logout(): void {
    const isOnline = JSON.parse(localStorage.getItem('isStillOnline'));
    if (isOnline) {
      this.databaseService.clearTableExamanesPeriodicosFiltrados();
      this.databaseService.clearTableExamanesReevaluacionFiltrados();
    }
    this.databaseService.clearTableExamanesCargados();
    this.authService.logout();
    this.alertService.openAlertSuccess('Ha salido de la aplicación');
  }
}
